import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBonaire = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_29_35)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
				fill: "#F0F0F0"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M3.5148 3.51481C0.943 6.08661 -0.217016 9.53539 0.0339062 12.8985L12.8984 0.0339672C9.53533 -0.217002 6.0866 0.943014 3.5148 3.51481Z",
				fill: "#FFDA44"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M4.28484 21.1908C8.99958 25.1575 16.0477 24.9229 20.4853 20.4853C24.923 16.0477 25.1576 8.99954 21.1909 4.28485L4.28484 21.1908Z",
				fill: "#0052B4"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M11.9572 11.5167L12.9913 10.9565L11.9572 10.3964C11.7158 8.82788 10.4765 7.58855 8.90798 7.34714L8.34778 6.31299L7.78763 7.3471C6.21919 7.5885 4.97991 8.82783 4.73841 10.3963L3.70425 10.9565L4.73836 11.5167C4.97981 13.0852 6.21909 14.3245 7.78758 14.5659L8.34778 15.6L8.90794 14.5659C10.4765 14.3245 11.7158 13.0852 11.9572 11.5167ZM8.34783 13.0435C7.19522 13.0435 6.26086 12.1092 6.26086 10.9565C6.26086 9.80386 7.19517 8.86955 8.34783 8.86955C9.50048 8.86955 10.4348 9.80386 10.4348 10.9565C10.4348 12.1092 9.50044 13.0435 8.34783 13.0435Z",
				fill: "black"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M8.34783 9.39131L8.79966 10.1739H9.70336L9.25148 10.9565L9.70336 11.7391H8.79966L8.34783 12.5217L7.896 11.7391H6.99234L7.44417 10.9565L6.99234 10.1739H7.896L8.34783 9.39131Z",
				fill: "#D80027"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_29_35",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			fill: "white"
		})
	}) })]
});
export default SvgBonaire;
